import { createAsyncThunk } from '@reduxjs/toolkit';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/dashboard/dashboard.response.type';
import * as Request from '@shared/models/dashboard/dashboard.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';
import { setTransactionsHistory } from '../slices/transaction.slice';

export const TransactionEndpoints = {
    getTransactionsHistory: config.base_url + '/rewards/coins',
};

export const fetchTransactionsHistory = createAsyncThunk<void, Request.ITransactionsHistoryQueryType>(
    TransactionEndpoints.getTransactionsHistory,
    async (query, { dispatch }) => {
        try {
            const { from, to, skip, take, type, page = 1 } = query.params;
            const params = query.params ? new URLSearchParams({ type, from, to, skip, take }) : '';
            const res = await httpService.get<AscResponse<Response.ITransactionsHistoryResponseType>>(
                `${TransactionEndpoints.getTransactionsHistory}?${params}`
            );

            dispatch(setTransactionsHistory({ ...res.data.data, page }));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(
                    err,
                    `Error fetching data from query ${TransactionEndpoints.getTransactionsHistory}`
                ),
                { type: 'error' }
            );
        }
    }
);
